import tw from 'twin.macro';

export const Wrapper = tw.div`
  fixed bottom-10 left-1/2 -translate-x-1/2 z-50
  flex justify-center items-center gap-3 py-2 px-4
  bg-white shadow-xl rounded-2xl text-textPrimary text-base font-bold
`;
